// Remembers the route the user navigated away from, so a page can tell
// how it was reached (e.g. "came back from a detail page").
let previous = null

export function trackNavigation (router) {
  router.afterEach((to, from) => {
    previous = from
  })
}

export function previousRoute () {
  return previous
}
